import { useState } from 'react';

import PropTypes from 'prop-types';
import { typesArray } from 'utils/personalities';

const unknownSrc = '/images/characters/unknown.svg';
const unknownAccentSrc = '/images/characters/unknown-2.svg';
const unknownTeam = '/images/characters/unknown-team.svg';
const getInitialSrc = (type, gender, tone) => {
  if (!type || type === 'unknown') {
    return unknownSrc;
  }
  if (type === 'unknown-2') {
    return unknownAccentSrc;
  }
  if (type === 'unknown-team') {
    return unknownTeam;
  }
  let baseName = `/images/characters/${type}/${gender}`;
  if (tone) {
    baseName += `-${tone}`;
  }
  baseName += '.svg';
  return baseName;
};
const Character = ({
  tone = 0, type = 'blank character with an unknown personality type indicator', gender = 'male', onError, className, homePage = false, ...attrs
}) => {
  const src = getInitialSrc(type, gender, tone);
  const [hasError, setHasError] = useState(false);
  const handleError = (e) => {
    if (hasError) {
      return;
    }
    setHasError(true);
    e.target.src = unknownSrc;
    e.target.onerror = null;
    onError?.();
  };
  const setImageRef = (el) => {
    if (el && el.naturalHeight === 0 && el.complete) {
      handleError({ target: el });
    }
  };
  return <img ref={setImageRef} src={src} alt={type} loading="lazy" className={className} {...attrs} {...(homePage ? {height: '135', width: '85'} : {})} onError={handleError} />;
};

Character.propTypes = {
  type: PropTypes.oneOf([...typesArray.map((t) => t.slug), 'unknown', 'unknown-2', 'unknown-team']),
  tone: PropTypes.oneOf([0, 1, 2, 3, 4, 5]),
};

export default Character;
